<template>
  <LayoutSearchFieldVertical>
    <div class="search-field-time-range">
      <BaseSelect
        class="jps-round-select time-range-select"
        v-model="mode"
        :options="['date', 'year']"
        :label-function="modeDisplay"
      />

      <form
        v-if="mode === 'date'"
        class="search-field-time-range-row"
        @submit.prevent="addDateRange"
      >
        <SearchFieldInputWithLabel
          :label="lss('開始日', 'Start date')"
          :id="`time-range-start-date-${field.key}`"
        >
          <input
            class="jps-input jps-keyword-input input-number"
            type="date"
            :id="`time-range-start-date-${field.key}`"
            v-model="fromDate"
            :placeholder="placeholder"
            @keyup.prevent.esc="fromDate = null"
          />
        </SearchFieldInputWithLabel>

        <SearchFieldInputWithLabel
          :label="lss('終了日', 'End date')"
          :id="`time-range-end-date-${field.key}`"
        >
          <input
            class="jps-input jps-keyword-input input-number"
            type="date"
            min="0"
            :id="`time-range-end-date-${field.key}`"
            v-model="toDate"
            @keyup.prevent.esc="toDate = null"
          />
        </SearchFieldInputWithLabel>

        <div class="time-range-nav">
          <UiButtonIcon
            class="jps-icon-button"
            tag="button"
            type="submit"
            :arialabel="lss('追加', 'Add')"
            icon="mdi/plus-circle"
            icon-size="size-5"
            styled="secondary"
          />
        </div>
      </form>

      <form v-else class="search-field-time-range-row" @submit.prevent="addRange">
        <SearchFieldInputWithLabel
          :label="lss('開始年', 'Start year')"
          :id="`time-range-start-year-${field.key}`"
        >
          <input
            class="jps-input jps-keyword-input input-number time-range-input-year"
            type="number"
            :id="`time-range-start-year-${field.key}`"
            v-model="fromYear"
            :placeholder="placeholder"
            @keyup.prevent.esc="fromYear = null"
          />
        </SearchFieldInputWithLabel>
         <SearchFieldInputWithLabel
          :label="lss('終了年', 'End year')"
          :id="`time-range-end-year-${field.key}`"
        >
          <input
            class="jps-input jps-keyword-input input-number time-range-input-year"
            type="number"
            :id="`time-range-end-year-${field.key}`"
            min="0"
            v-model="toYear"
            @keyup.prevent.esc="toYear = null"
          />
        </SearchFieldInputWithLabel>
        <div class="time-range-nav">
          <UiButtonIcon
            class="jps-icon-button"
            tag="button"
            type="submit"
            :arialabel="lss('追加', 'Add')"
            icon-size="size-5"
            styled="secondary"
            icon="mdi/plus-circle"
          />
        </div>
      </form>
    </div>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { lss } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { placeholder } = useSearchFieldBase(props)

const mode = ref<'date' | 'year'>('date')

const fromDate: Ref<string> = ref(null)
const toDate: Ref<string> = ref(null)

const modeDisplay = value => {
  if (value === 'date') return lss('日付', 'Date')
  else return lss('年', 'Year')
}

const addDateRange = () => {
  if (fromDate.value === '') fromDate.value = null
  if (toDate.value === '') toDate.value = null
  if (fromDate.value == null && toDate.value == null) return
  let r: QueryRange = {}
  if (fromDate.value != null) r.from = fromDate.value
  if (toDate.value != null) r.to = toDate.value
  props.ss.setRange(props.field.key, [r])
}

const fromYear: Ref<string> = ref(null)
const toYear: Ref<string> = ref(null)

const addRange = () => {
  if (fromYear.value === '') fromYear.value = null
  if (toYear.value === '') toYear.value = null
  if (fromYear.value == null && toYear.value == null) return
  let year: QueryRange = {}
  if (fromYear.value != null) year.from = fromYear.value
  if (toYear.value != null) year.to = toYear.value
  props.ss.setRange(props.field.key, [year])
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.search-field-time-range,
.search-field-time-range-row {
  display: flex;
  gap: 0.25rem 0.75rem;
  flex-wrap: wrap;
  align-items: end;

  .time-range-input-year {
    max-width: 5rem;
    text-align: right;
  }
}

.time-range-select {
  margin: 0;

  :deep(select) {
    line-height: 1.8;
  }
}

.time-range-nav {
  min-height: 2.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
